module.exports = __webpack_public_path__ + "static/media/loader_spin_green.20d78e93.gif";